<template>
  <div class="order">
    <van-sticky>
      <van-nav-bar title="我的预约" left-arrow @click-left="goback()" />
    </van-sticky>

    <van-pull-refresh
      v-model="refreshing"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <div class="order_centent">
          <template v-for="(items, indexs) in reservationVisitList">
            <div class="order_list" :key="indexs">
              <!-- 订单详情 -->
              <div class="list_detail">
                <van-image
                  height="80"
                  width="80"
                  :src="items.siteVo.imageList[0].url"
                  fit="cover"
                  radius="7"
                />
                <div class="list_desc fs11 color999">
                  <div class="line1 fs16 color000">
                    {{ items.siteVo.name }}
                  </div>
                  <div>
                    租金：{{ items.siteVo.monthlyRent }}元/月
                    &nbsp;&nbsp;&nbsp;&nbsp; 面积：{{ items.siteVo.area }}㎡
                  </div>
                  <div>预约看房时间：{{ items.expectedTime }}</div>
                  <div>
                    姓名：{{ items.contactName }}({{
                      items.contactGender_name
                    }})&nbsp;&nbsp;&nbsp;&nbsp;电话：{{ items.contactNumber }}
                  </div>
                </div>
              </div>

              <div class="list_message">
                {{ items.remark }}
              </div>

              <div class="list_btn">
                <div class="fs13 color999">
                  提交时间：{{ items.createtime }}
                </div>
                <div class="btn">
                  <van-button
                    size="small"
                    type="info"
                    @click="toSiteLease(items.siteVo.id)"
                    >立即租赁</van-button
                  >
                </div>
              </div>
            </div>
          </template>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Button, Icon, Image, List, PullRefresh } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      params: {
        keyword: "",
        page: 1,
        size: 8,
      },
      //我的预约
      reservationVisitList: [],
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      refreshing: false,
    };
  },

  created() {
    // 我的预约-列表
    this.getReservationVisitList();
  },

  methods: {
    
    //跳转立即租赁
    toSiteLease(id) {
      this.$router.push({
        path: "/home/siteLease",
        query: { id: id },
      });
    },

    //下拉刷新
    onRefresh() {
      var that = this;
      setTimeout(() => {
        that.params.page = 1;
        // 我的预约-列表
        that.getReservationVisitList();
        that.refreshing = false;
        that.finished = false;
      }, 1000);
    },

    //上拉加载
    onLoad() {
      var that = this;
      setTimeout(() => {
        // 我的预约-列表
        that.getReservationVisitList();
      }, 1000);
    },

    // 我的预约-列表
    getReservationVisitList() {
      var that = this;
      that.$api
        .reservationVisitListAPI(that.params)
        .then(function (res) {
          if (res.data.code === 200) {
            // 如果是第一次进入页面page==1 直接赋值
            if (that.params.page === 1) {
              that.reservationVisitList = res.data.dataList;
            } else {
              that.reservationVisitList = [
                ...that.reservationVisitList,
                ...res.data.dataList,
              ];
            }
            // 当还有数据是page++
            if (res.data.dataList.length > 0) {
              that.params.page++;
              that.loading = false;
            } else {
              // 如果没有数据加载完毕
              that.finished = true;
            }
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //返回上一页
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.order {
  .order_centent {
    padding-top: 10px;
    border-top: 10px solid #f4f3f8;
    position: relative;

    .content_number {
      width: 17px;
      height: 17px;
      line-height: 20px;
      background: #ff5151;
      color: #fff;
      border-radius: 50%;
      text-align: center;
      font-size: 13px;
      position: absolute;
      top: 0px;
      left: 55%;
    }
  }

  .order_list {
    border-bottom: 6px solid #f3f3f3;
    padding: 20px 15px;

    .list_message {
      color: #999;
      background: #f4f3f8;
      height: 75px;
      border-radius: 10px;
      padding: 10px;
      font-size: 14px;
    }

    .list_ordernum {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        color: #ff5151;
        font-size: 11px;
      }
    }

    // 订单详情
    .list_detail {
      display: flex;
      padding: 15px 0px;
      justify-content: space-between;

      .list_desc {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 240px;
      }
    }

    .list_btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 5px;

      .btn {
        display: flex;
        .van-button {
          margin-left: 8px;
          color: #fff !important;
        }
      }
    }

    .btn {
      font-size: 11px;
      color: #000;

      /deep/ .van-button {
        color: #333 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/personal/appointment.vue